import React, { Component } from 'react';
import PaginatedTable from '../PaginatedTable';
import AccountsApi from '../../api/accounts';
import AdministratorApi from "../../api/administrators";
import Paper from '@mui/material/Paper';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { showError } from '../../actions/uiActions';
import Formatter from '../../utils/Formatter';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import SearchIcon from '@mui/icons-material/Search';
import Cancel from '@mui/icons-material/Cancel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Validators from '../../utils/Validators';
import userFilter from './userFilter.json';
import Select from '@mui/material/Select';
import { Checkbox, ListItemText, Tooltip } from '@mui/material';
import DomainApi from '../../api/domains';
import { withRouter } from '../../utils/withRouter';
import FormsFilter from '../FormsFilter';
import { format } from 'date-fns';

const activations = [
    { id: 0, name: "All" },
    { id: 1, name: "Manual" },
    { id: 2, name: "Automatic" },
]

const leadFilter = ["analysis", "artificial-msd"]
class Users extends Component
{
    state = {
        accounts: [],
        page: 0,
        count: 0,
        search: '',
        loading: false,
        searching: false,
        menu_open: false,
        anchorElement: null,
        status: 'all',
        sort: 'desc',
        accountManagers: [],
        selectedAccountManagers: [],
        open: false,
        domains: [],
        selectedDomains: [],
        is_domain_open: false,
        is_method_open: false,
        activationMethod: "",
        resetFields: false,
        formsFilter: {
            form: '',
            status: '',
            from: '',
            to: '',
        }
    };
    componentWillMount()
    {
        if (
            (this.props.match.params.sort === 'asc' ||
                this.props.match.params.sort === 'desc') &&
            Validators.isInteger(this.props.match.params.page)
        )
        {
            const queryParms = new URLSearchParams(this.props.location.search)
            const selectedDomains = queryParms.get('domains') ? queryParms.get('domains').split(',') : []
            const selectedAccountManagers = queryParms.get('managers') ? queryParms.get('managers').split(',') : []
            const activationMethod = queryParms.get('activation') ? queryParms.get('activation') : "All"
            const form = queryParms.get('form') ? queryParms.get('form') : ""
            const status = queryParms.get('formStatus') ? queryParms.get('formStatus') : ""
            const from = queryParms.get('from') ? queryParms.get('from') : ""
            const to = queryParms.get('to') ? queryParms.get('to') : ""
            this.setState({
                sort: this.props.match.params.sort,
                page: this.props.match.params.page,
                status: this.props.match.params.status || 'all',
                search: this.props.match.params.search || '',
                selectedDomains,
                selectedAccountManagers,
                activationMethod,
                formsFilter: {
                    form,
                    status,
                    from,
                    to
                }
            },
                () => this.load(this.props.match.params.page)
            );
        } else
        {
            this.load(0);
        }
        this.getFilterArray();
    }
    load = async (page = 0, reset = false) =>
    {
        try
        {
            const { formsFilter } = this.state
            const form = reset ? "" : formsFilter.form;
            const status = reset ? "" : formsFilter.status;
            const from = reset ? "" : formsFilter.from;
            const to = reset ? "" : formsFilter.to;
            const account_mgr_id = this.state.selectedAccountManagers.join(',');
            const domain_id = this.state.selectedDomains.join(',');
            this.setState({ loading: true, searching: this.state.search ? true : false });
            const method = this.state.activationMethod === "All" ? "" : this.state.activationMethod
            const result = await AccountsApi.load(
                page,
                this.state.status,
                this.state.search.trim(),
                this.state.sort,
                this.props.status,
                account_mgr_id,
                domain_id,
                method,
                form,
                status,
                from,
                to
            );
            this.setState({ loading: false, ...result }, () =>
            {
                this.props.history.push(
                    `/${this.props.route || 'users'}/p/${this.state.sort
                    }/${result.page}/${this.state.status}/${this.state.search}?domains=${domain_id}&managers=${account_mgr_id}&activation=${method}&form=${form}&formStatus=${status}&from=${from}&to=${to}`
                )
            }
            );
        } catch (error)
        {
            this.setState({ loading: false });
            this.props.showError();
        }

    };

    getFilterArray = async () =>
    {
        const accountManagers = await AdministratorApi.getList();
        this.setState({ accountManagers })
        const domains = await DomainApi.all();
        this.setState({ domains })
    }

    handleSelectManagers = (event, child) =>
    {
        const { props: { value } } = child;
        const accountManagerId = value._id;
        const { selectedAccountManagers } = this.state;
        if (selectedAccountManagers.find(eachAccountManagerId => eachAccountManagerId === accountManagerId))
        {
            this.setState({
                selectedAccountManagers: selectedAccountManagers.filter(eachAccountManagerId => eachAccountManagerId !== accountManagerId)
            })
        }
        else
        {
            this.setState({
                selectedAccountManagers: [...selectedAccountManagers, accountManagerId]
            })
        }
    }

    getManagerFilterValue = (selectedManagers) =>
    {
        if (selectedManagers.length === 0)
        {
            return <span>Filter by Account Manager</span>;
        }
        const selectedAccountManagersDetails = this.state.accountManagers.filter(eachManager => selectedManagers.includes(eachManager._id))
        return selectedAccountManagersDetails.map(each => each.name).join(',');
    }

    getDomainFilterValue = (selectedDomains) =>
    {
        if (selectedDomains.length === 0)
        {
            return <span>Filter by Domain</span>;
        }
        const selectedDomainDetails = this.state.domains.filter(eachManager => selectedDomains.includes(eachManager._id))
        return selectedDomainDetails.map(each => each.name).join(',');
    }
    getActivationValue = (value) =>
    {
        if (value)
        {
            return <span>{value}</span>
        }
        return <span>Filter by Activation method</span>;
    }

    handleSelectDomains = (event, child) =>
    {
        const { props: { value } } = child;
        const domainId = value._id;
        const { selectedDomains } = this.state;
        if (selectedDomains.find(item => item === domainId))
        {
            this.setState({ selectedDomains: selectedDomains.filter(eachDomainId => eachDomainId !== domainId) })
        } else
        {
            this.setState({ selectedDomains: [...selectedDomains, domainId] })
        }
    }

    accountStatus = (userAccount) =>
    {
        let accountStatus = '';
        if ((userAccount || {}).isArchived)
        {
            accountStatus = 'Deactivated';
        } else if (userAccount.hasOwnProperty('loanType') && userAccount.loanType === 'private')
        {
            accountStatus = 'Private';
        } else if (userAccount.hasOwnProperty('loanType') && userAccount.loanType === 'isForProfit')
        {
            accountStatus = 'For Profit';
        }
        else if (userAccount.hasOwnProperty('loanType') && userAccount.loanType === 'isPartTime')
        {
            accountStatus = 'Part-time';
        }
        else
        {
            accountStatus = userAccount.status
        }
        return accountStatus;
    }
    handleSelectActivation = (event, child) =>
    {
        const { props: { value } } = child;
        this.setState({ activationMethod: value.name })
    }

    getLoanValues = (account, type) =>
    {
        if (account.hasOwnProperty('loanType'))
        {
            if (account.loanType === "private")
            {
                return "Private"
            } else if (account.loanType === "isForProfit")
            {
                return "For Profit"
            }
            return account[type]
        }

        return account[type]
    }


    handleSelectForms = (e, child, name) =>
    {
        const {
            props: { value },
        } = child;
        const formValue = value.value;


        const payload = {
            ...this.state.formsFilter,
            [name]: formValue,
        };
        this.setState({ formsFilter: payload })
    };

    handleDate = (type, value) =>
    {
        const payload = {
            ...this.state.formsFilter,
            [type]: value,
        };
        this.setState({ formsFilter: payload }, () => this.load())
    };

    resetFormsFilterFIelds = () =>
    {
        this.setState({
            ...this.state,
            loading: this.state.loading,
            formsFilter: {
                form: '',
                status: '',
                from: '',
                to: '',
            }
        })
    }

    determineDateColumnName = () =>
    {
        if (leadFilter.includes(this.state.status))
        {
            return "First Visit Date";
        } else if (this.state.status === 'leads-awaiting-review')
        {
            return "MSD Uploaded On"
        } else if (this.state.status === 'all')
        {
            return "Date"
        } else
        {
            return "Activation Date"
        }
    }

    isTerminatedPendingArchive = (account) => account?.terminatedDate && !account.isArchived

    getMeetingStatus = (account) =>
    {
        if (!account.meeting) return false
        const currentDate = new Date()
        const meetingStartDate = new Date(account.meeting.properties.hs_meeting_start_time)
        if (meetingStartDate < currentDate) return false
        return true
    }


    render()
    {
        return (
            <div>
                <div className="row mb-6">
                    <div className="col-4">
                        <Paper style={{ display: 'flex' }} elevation={1}>
                            <InputBase
                                onKeyDown={e =>
                                {
                                    if (e.keyCode == 13) this.load(0);
                                }}
                                disabled={this.state.searching}
                                value={this.state.search}
                                onChange={e => this.setState({ search: e.target.value })}
                                placeholder="Find user..."
                                style={{ width: '90%', paddingLeft: '20px' }}
                            />
                            {this.state.searching && (
                                <IconButton
                                    onClick={() =>
                                        this.setState({ searching: false, search: '' }, () =>
                                            this.load(0)
                                        )
                                    }
                                    aria-label="Clear"
                                >
                                    <Cancel />
                                </IconButton>
                            )}
                            <Divider
                                style={{
                                    width: 1,
                                    height: 34,
                                    margin: 4
                                }}
                            />
                            <IconButton onClick={() => this.load(0)} aria-label="Search">
                                <SearchIcon />
                            </IconButton>
                        </Paper>
                    </div>
                </div>
                <div className="row mt-2 mb-16">
                    <div className="col-3">
                        <Paper style={{ display: 'flex' }} elevation={1}>
                            <div className="data-filter">
                                {userFilter.find(({ value }) => value === this.state.status).label}
                            </div>
                            <Divider
                                style={{
                                    width: 1,
                                    height: 34,
                                    margin: 4
                                }}
                            />
                            <React.Fragment>
                                <IconButton
                                    onClick={e =>
                                        this.setState({
                                            menu_open: !this.state.menu_open,
                                            anchorElement: e.currentTarget
                                        })
                                    }
                                    variant="contained"
                                >
                                    <ArrowDropDown />
                                </IconButton>


                                <Menu
                                    onClose={() => this.setState({ menu_open: false })}
                                    anchorEl={this.state.anchorElement}
                                    open={this.state.menu_open}
                                >
                                    {userFilter.map(({ value, label }, index) => (
                                        <div key={index}>
                                            <MenuItem
                                                onClick={() => this.setState({ menu_open: false, status: value }, () =>
                                                {
                                                    this.resetFormsFilterFIelds()
                                                    this.load(this.state.page, true)
                                                })}
                                                selected={this.state.status === value} className="data-filter">
                                                {label}
                                            </MenuItem>
                                            {value === "all" && <Divider />}
                                        </div>

                                    ))}

                                </Menu>
                            </React.Fragment>
                        </Paper>
                    </div>
                    <div className="col-3">
                        <Paper style={{ display: 'flex' }} elevation={1}>
                            <Select
                                labelId="accountmanagers"
                                className='data-filter'
                                value={this.state.selectedAccountManagers}
                                renderValue={this.getManagerFilterValue}
                                open={this.state.open}
                                style={{ width: '100%' }}
                                multiple
                                onChange={this.handleSelectManagers}
                                displayEmpty
                                onClose={() => this.setState({ open: false }, () => this.load(0))}
                                onOpen={() => this.setState({ open: true })}
                            >
                                {this.state.accountManagers.map(({ _id, name }) => (
                                    <MenuItem key={_id} value={{ name, _id }}>
                                        <Checkbox checked={this.state.selectedAccountManagers.includes(_id)} />
                                        <ListItemText primary={name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </Paper>
                    </div>
                    <div className="col-3">
                        <Paper style={{ display: 'flex' }} elevation={1}>
                            <Select
                                labelId="domains"
                                className='data-filter'
                                value={this.state.selectedDomains}
                                renderValue={this.getDomainFilterValue}
                                open={this.state.is_domain_open}
                                style={{ width: '100%' }}
                                multiple
                                onChange={this.handleSelectDomains}
                                displayEmpty
                                onClose={() => this.setState({ is_domain_open: false }, () => this.load(0))}
                                onOpen={() => this.setState({ is_domain_open: true })}
                            >
                                {this.state.domains.map(({ _id, name }) => (
                                    <MenuItem key={_id} value={{ name, _id }}>
                                        <Checkbox checked={this.state.selectedDomains.includes(_id)} />
                                        <ListItemText primary={name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </Paper>
                    </div>
                    <div className="col-3">
                        <Paper style={{ display: 'flex' }} elevation={1}>
                            <Select
                                labelId="activate"
                                className='data-filter'
                                value={this.state.activationMethod}
                                renderValue={this.getActivationValue}
                                open={this.state.is_method_open}
                                style={{ width: '100%' }}
                                onChange={this.handleSelectActivation}
                                displayEmpty
                                onClose={() => this.setState({ is_method_open: false }, () => this.load(0))}
                                onOpen={() => this.setState({ is_method_open: true })}
                            >
                                {activations.map(({ id, name }) => (
                                    <MenuItem key={id} value={{ name, id }}>
                                        <ListItemText primary={name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </Paper>
                    </div>
                </div>
                <FormsFilter formFilter={this.state.formsFilter}
                    onSelectForm={this.handleSelectForms}
                    onSelectDate={this.handleDate}
                    onClose={() => this.setState({}, () => this.load(0))} />
                <div className="line-break"></div>
                <Paper>
                    <PaginatedTable
                        goToPage={this.load}
                        count={parseInt(this.state.count.toString())}
                        page={parseInt(this.state.page.toString())}
                        loading={this.state.loading}
                        rows={this.state.accounts.map(account =>
                        {
                            return {
                                properties: {
                                    onClick: () => this.props.onAccountSelected(account.id),
                                    key: account.id,
                                    className: 'clickable'
                                },
                                columns: [
                                    {
                                        properties: {
                                            key: `${account.id}-0`
                                        },
                                        value: account.date
                                    },
                                    {
                                        properties: {
                                            key: `${account.id}-1`
                                        },
                                        value:
                                            (account.name &&
                                                Formatter.printMaxCharacters(account.name, 30)) ||
                                            'Unknown'
                                    },
                                    {
                                        properties: {
                                            key: `${account.id}-2`,
                                            className: 'width15pct'
                                        },
                                        value:
                                            (account.email &&
                                                Formatter.printMaxCharacters(account.email, 30)) ||
                                            'Unknown'
                                    },
                                    {
                                        properties: {
                                            key: `${account.id}-3`,
                                            className: `badge-container ${account.strategy === 'Awaiting Review'
                                                ? 'none'
                                                : account.strategy
                                                }`
                                        },
                                        value: (
                                            <div>
                                                {this.getLoanValues(account, "strategy")}
                                            </div>
                                        )
                                    },
                                    ...(this.state.accounts.some(acc => acc.meeting !== undefined) ? (() =>
                                    {
                                        const meetingStatus = this.getMeetingStatus(account);
                                        return [{
                                            properties: {
                                                key: `${account.id}-4`,
                                                className: !meetingStatus ? 'text-muted' : ''
                                            },
                                            value: (
                                                <div>
                                                    {meetingStatus ? <Tooltip title={`Scheduled time: ${format(account.meeting.properties.hs_meeting_start_time, 'MM-dd-yyyy hh:mm a')}`}>Yes</Tooltip> : <span>No</span>}
                                                </div>
                                            )
                                        }];
                                    })() : []),
                                    {
                                        properties: {
                                            key: `${account.id}-5`
                                        },
                                        value: (
                                            <div style={account.hasDefaultLoans ? { color: '#da0422' } : {}}>
                                                {account.hasOwnProperty('loanType') &&
                                                    account.loanType === 'private'
                                                    ? 'Private'
                                                    : account.balance > 0
                                                        ? `$${Formatter.money(account.balance)}`
                                                        : '-'}
                                            </div>
                                        )

                                    },
                                    {
                                        properties: { key: `${account.id}-9` },
                                        value: account.accountManager
                                    },
                                    {
                                        properties: {
                                            key: `${account.id}-6`,
                                            className: `badge-container ${account.status}`
                                        },
                                        value: (
                                            <div style={this.isTerminatedPendingArchive(account) ? { color: '#da0422' } : {}}>
                                                {this.accountStatus(account)}
                                            </div>
                                        )
                                    },
                                    {
                                        properties: {
                                            key: `${account.id}-7`,
                                            className: `badge-container ${account.outcome}`
                                        },
                                        value: (
                                            <div>
                                                {this.getLoanValues(account, "outcome")}
                                            </div>
                                        )
                                    }
                                ]
                            };
                        })}
                        emptyMessage="No users found"
                        columns={[
                            {
                                name: this.determineDateColumnName(),
                                properties: {
                                    key: 0,
                                    className: 'clickable'
                                },
                                sortable: true,
                                asc: this.state.sort === 'asc',
                                onClick: () =>
                                {
                                    this.setState(
                                        { sort: this.state.sort === 'asc' ? 'desc' : 'asc' },
                                        () => this.load(this.state.page)
                                    );
                                }
                            },
                            {
                                name: 'Name',
                                properties: {
                                    key: 1,
                                    className: 'width15pct'
                                }
                            },
                            {
                                name: 'Email',
                                properties: {
                                    key: 2,
                                    className: 'width15pct'
                                }
                            },
                            {
                                name: 'PeopleJoy Strategy',
                                properties: {
                                    key: 3,
                                    className: 'width15pct'
                                }
                            },
                            ...(this.state.accounts.some(acc => acc.meeting !== undefined) ? [{
                                name: 'Call booked',
                                properties: {
                                    key: 4,
                                    className: 'width15pct'
                                }
                            }] : []),
                            {
                                name: 'Balance',
                                properties: {
                                    key: 5,
                                    className: 'width10pct'
                                }
                            },
                            {
                                name: 'Manager',
                                properties: {
                                    key: 6,
                                    className: 'width10pct'
                                }
                            },
                            {
                                name: 'Status',
                                properties: {
                                    key: 7,
                                    className: 'width15pct'
                                }
                            },
                            {
                                name: 'Outcome',
                                properties: {
                                    key: 8,
                                    className: 'width10pct'
                                }
                            }
                        ]}
                        pageSize={50}
                    />
                </Paper>
            </div>
        );
    }
}
const mapStateToProps = state =>
{
    return state;
};
Users.propTypes = {
    showError: PropTypes.func.isRequired
};
export default withRouter(connect(mapStateToProps, { showError })(Users));
